export const JOURNAL = {
	memberPage: 'member-journal-page',
	summaryTotal: 'journal-summary-total',
	summaryWinrate: 'journal-summary-winrate',
	summaryPl: 'journal-summary-pl',
	form: 'journal-form',
	submit: 'journal-submit',
	row: 'journal-row',
	editBtn: 'journal-edit-button',
	deleteBtn: 'journal-delete-button',
	adminPage: 'admin-journal-report-page',
	reportEntries: 'report-total-entries',
	reportUsers: 'report-active-users',
	reportPl: 'report-aggregate-pl',
};
